export default __webpack_public_path__ + "static/media/link_off.e521b5de.svg";